// Import children components
import './requirement';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-template-sidebar-requirements' )
export class AutomatorTemplateSidebarRequirements extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * The integrations required by this recipe.
	 * Each item in the array represents the ID of an integration.
	 *
	 * @type {Array<Number>}
	 * @property {Array<Number>} requirements - A list of integration IDs required for the recipe.
	 * Attribute name in HTML: none (non-reflected property).
	 * Default: `[]`.
	 */
	@property( { type: Array, attribute: false } )
	accessor requirements = [];

	/**
	 * A flag indicating if the template operates in standalone mode, typically used when the template library is embedded on an external site. Disables installation-related functionality and hides import buttons. Default is false.
	 *
	 * @type {Boolean} The standalone mode flag
	 */
	@property( { type: Boolean, attribute: 'standalone-mode' } )
	accessor standaloneMode = false;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="requirements">
				<div class="requirements-heading">
					${ escapeHTML( __( 'Requirements', 'uncanny-automator' ) ) }
				</div>

				<div class="requirements-items">
					${ repeat(
						this.requirements,
						integrationID => integrationID,
						integrationID => html`
							<uap-template-sidebar-requirement
								integration-id=${ integrationID }
								?standalone-mode=${ this.standaloneMode }
							></uap-template-sidebar-requirement>
						`
					) }
				</div>
			</div>
		`;
	}
}
